import React from 'react';
import './Header.css';

export default function Header() {
  return (
    <div className="header">
      <h1>Lets Meet</h1>
      <a href="https://sms-home.netlify.app/dashboard">
        <h1>Home</h1>
      </a>
    </div>
  );
}
